import { Component, inject, signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ICellRendererParams } from 'ag-grid-community';
import { TechnicalEligibilityApiService } from '../../../services/technical-eligibility-api-service';

@Component({
  selector: 'app-provider-response-name-cell-renderer-component',
  imports: [MatIconModule, MatTooltipModule],
  templateUrl: './provider-response-name-cell-renderer-component.html',
  styleUrl: './provider-response-name-cell-renderer-component.css',
})
export class ProviderResponseNameCellRendererComponent {
  public readonly providerResponse = signal<any>(undefined);
  public readonly providerName = signal<string>('');
  params!: any;

  public readonly technicalEligibilityApiService = inject(TechnicalEligibilityApiService);
  
  agInit(params: ICellRendererParams): void {
    this.refresh(params);
  }

  refresh(params: ICellRendererParams): boolean {
    this.params = params;
    this.providerName.set(this.technicalEligibilityApiService.getProviderDisplayedName(params.data.provider));
    this.providerResponse.set(params.data);
    return true;
  }
}
